import React, { useState } from 'react'
import ReactModal from 'react-modal'

function DescripcionAgrupada(props) {
    const [modalIsOpen, setIsOpen] = useState(false);
    const handleOpenModalTest = () => {
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
    };
    return (
        <div>
            <button variant="contained" className='btn btn-primary ' color="primary" onClick={handleOpenModalTest} > Descripcion</button>
            <ReactModal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Crear Institucion">
                <div className="container">
                    <div className="text-center">
                        <div class="container-fluid">
                            <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Descripción</h6>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive">
                                        <form className="user">
                                            <div className="form-group row">
                                                <div className="col-sm-12">
                                                <textarea className="form-control" id="exampleFormControlTextarea1" rows="10"  placeholder={props.descripcion} disabled />
                                                </div>
                                            </div>
                                           
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>
        </div>
    )
}

export default DescripcionAgrupada